export default "__VITE_ASSET__CKNbd3XW__"